import script from "./AiCheckDialogHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckDialogHeader.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckDialogHeader.vue?vue&type=style&index=0&id=9a6465f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a6465f0"]])

export default __exports__